<template>
  <div>
    <ShowHome2 />
  </div>
</template>

<script>
import ShowHome from "@/components/General/ShowHome";
import ShowHome2 from "@/components/General/ShowHome2";
export default {
  components: {
    ShowHome,
    ShowHome2
  },
  methods: {

  }
};
</script>
<style>  
  .font-color-home {
    color: #28385C;
  }
  
</style>
